import { useEffect, useState } from "react";
import { CgSpinner } from "react-icons/cg";
import { IoMdClose } from "react-icons/io";
import { useDispatch, useSelector } from "react-redux";
import nodeinstance from "../../../../../nodeInstance";
import { setAppError } from "../../../../../store/userSlice";

import React from "react";
import ProjectDropDown from "../../../../../ReusableComponents/ProjectDropDown/ProjectDropDown";
import { getProjectData } from "../../../../../store/Api";

export default function BulkUpdatePopUp({
  PopUp,
  setPopUp,
  callBack,
  listData = [],
  url,
  project_id,
}) {
  console.log("project_id to be seen here....", listData);
  const token = localStorage.getItem("nodeToken");

  const [formData, setFormData] = useState({
    projectId: "",
    contractnumber: "",
    mobilizationDate: "",
    clientId: "",
    actual_profession_id: "",
    Employeelocation: "",
  });

  const dispatch = useDispatch();

  const Project = useSelector((state) => state.projectData);
  console.log("project data to be displayed here...", Project);

  useEffect(() => {
    dispatch(getProjectData(token));
  }, [PopUp]);
  const [loading, setLoading] = useState(false);

  const [error, setError] = useState(false);
  const [projectId, setProjectId] = useState("");

  useEffect(() => {
    const filterId = Project?.data?.filter(
      (item) => item.project_id === listData && listData[0].project_id
    );
    setProjectId(filterId);
  }, [PopUp]);

  const submitHandler = async (e) => {
    console.log("project.......", listData);
    var type = {
      mobilization_date: formData.mobilizationDate,
      project_id: listData && listData[0]?.Unique_project_id,
      client_id: formData.clientId,
      emp_data: Array.isArray(listData)
        ? listData
            .filter(
              (fil) =>
                new Date(fil.arrival_date) <= new Date(formData.mobilizationDate)
            )
            .map((e) => ({
              employee_id: e.candidate_id, // Access properties of each element 'e'
              actual_profession_id: formData.actual_profession_id,
              employee_contract_start_Date: e.arrival_date,
              project_id: e.Unique_project_id,
              Employeelocation: formData.Employeelocation,
              Basicsalary: e.Basic_salary,
              Totalsalary: e.total_salary,
            }))
        : [],
    };
    if (type.emp_data.length <= 0) {
      dispatch(
        setAppError({
          msg: "Employees Arrival Date exceeds. No employee mobilized",
        })
      );
      return;
    }
    console.log(
      "..........Data to be seen in the console for reference...",
      type
    );
    setLoading(true);
    try {
      const response = await nodeinstance.post(
        `/mobilization/addCandidatesBulk`,
        type,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 200) {
        dispatch(
          setAppError({
            msg: response?.data?.message,
            color: "bg-green-700",
          })
        );
        setPopUp(false);
        callBack();
        // setChecked([])
      } else {
        dispatch(
          setAppError({
            msg: response.data.message,
          })
        );
      }
    } catch (err) {
      setError(err);
      setLoading(false);
      console.log("error", err);
      dispatch(
        setAppError({
          msg: "failed to update mobilization for employees.",
        })
      );
    }
  };

  // console.log("filterId......", filterId);
  const getProjectsId = async (e) => {
    const reqObj = {
      id: listData && listData[0].project_id,
    };
    try {
      const response = await nodeinstance.post(
        `mobilization/getDetailsByProject`,
        reqObj,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 200) {
        var setData = response.data.data[0];
        console.log(setData, "jdcgyygdctygtygtydcgygytdytftydftcfytsdfy");
        setFormData({
          ...formData,
          contractnumber: setData?.contract_number,
          clientId: setData?.client_id,
          actual_profession_id: setData?.actual_profession_id,
          Employeelocation: setData?.Sector_Name,
        });
      }
    } catch (err) {
      console.log("error...........", err);
      dispatch(
        setAppError({
          msg: "failed to load data",
        })
      );
      setLoading(false);
      console.log("error", err);
    }
  };
  useEffect(() => {
    getProjectsId();
    // alert("................................");
  }, [PopUp]);

  const [data, setData] = useState(
    listData && listData[0].project_id ? listData && listData[0].project_id : ""
  );

  const handleProjectChange = (e) => {
    setData(e.target.value);
  };
  return (
    <>
      <div
        className={`fixed z-50 top-0 left-0 min-w-full min-h-screen bg-black/50  justify-center items-center ${
          PopUp ? "flex" : "hidden"
        }`}
      >
        <div className="max-w-lg w-full h-auto   rounded-md bg-white/95 flex  flex-col p-4 relative">
          {/* <div className="flex justify-between w-full">
            <h1
              className="text-md font-semibold cursor-pointer"
              onClick={() => {
                setPopUp(false);
              }}
            >
              <IoMdClose />
            </h1>
          </div> */}
          <div className="form-control w-full mt-2">
            <label className="label">
              <span className="label-text">MOBILIZATION DATE</span>
            </label>

            <input
              // type="date"
              type="Date"
              value={formData.mobilizationDate}
              max={new Date().toISOString().split("T")[0]}
              className="input input-sm input-bordered"
              required
              onChange={(e) =>
                setFormData({
                  ...formData,
                  mobilizationDate: e.target.value,
                })
              }
              onKeyDown={(e) => e.preventDefault()}
            />
          </div>

          <div className="form-control w-full">
            <label className="label">
              <span className="label-text">PROJECT ID</span>
            </label>
            <select
              //   {...register("visaprovider")}
              className="border-[1px] border-border dark:bg-dark rounded-md p-1 py-2 text-xs"
              onChange={handleProjectChange}
              value={data ? data : ""}
              disabled
            >
              <option value="">{"SELECT VALUE"}</option>
              {Project?.data?.map((data, index) => (
                <React.Fragment key={index}>
                  <option value={data.project_id}>{data.name}</option>
                </React.Fragment>
              ))}
            </select>
          </div>

          <div className="form-control w-full">
            <label className="label">
              <span className="label-text">CONTRACT NO</span>
            </label>
            <input
              value={formData.contractnumber}
              placeholder="POPULATE AS PER THE PROJECT ID SELECTION"
              type="text"
              className="input input-sm input-bordered"
              required
              disabled
              onChange={(e) =>
                setFormData({
                  ...formData,
                  contractnumber: e.target.value,
                })
              }
            />
          </div>

          <div className="form-control w-full">
            <label className="label">
              <span className="label-text">Employee Location</span>
            </label>
            <input
              value={formData.Employeelocation}
              placeholder="POPULATE AS PER THE PROJECT ID SELECTION"
              type="text"
              className="input input-sm input-bordered"
              required
              onChange={(e) =>
                setFormData({
                  ...formData,
                  Employeelocation: e.target.value,
                })
              }
            />
          </div>

          <div className="w-full">
            <div className="w-full flex flex-col gap-3 my-3 p-5">
              <div className="flex gap-3 w-full justify-center">
                <button
                  className="p-3 bg-blue text-white rounded-md w-full max-w-xs m-2 my-4 flex gap-3 justify-center items-center text-sm"
                  onClick={() => {
                    setPopUp(false);
                  }}
                >
                  Cancel
                </button>
                <button
                  // type="submit"
                  className="p-3 bg-red text-white rounded-md w-full max-w-xs m-2 my-4 flex gap-3 justify-center items-center text-sm"
                  onClick={() => submitHandler()}
                >
                  <p>Submit</p>
                  {loading ? <CgSpinner className="animate-spin" /> : ""}
                </button>
              </div>
            </div>
          </div>

          {/* <label>error</label> */}
        </div>
      </div>
    </>
  );
}
